import React, { useState, useEffect } from 'react';
import Icon from '../icon';
import { StyledNotification } from './style';
var Notification = function (props) {
    if (props === void 0) { props = {
        duration: 4.5,
        message: '',
        type: 'success',
    }; }
    var type = props.type, isExpandable = props.isExpandable, isExpandableVisible = props.isExpandableVisible, expandableContent = props.expandableContent, thumbnail = props.thumbnail, title = props.title, message = props.message, duration = props.duration, onClose = props.onClose;
    var closeTimer;
    var _a = useState(!!isExpandableVisible), isExpanded = _a[0], setIsExpanded = _a[1];
    var notificationClassname = "notification " + type + " open " + (isExpandable
        ? 'expandable'
        : '') + " " + (isExpanded ? 'expandable-open' : '');
    useEffect(function () {
        startCloseTimer();
        return function clear() {
            clearCloseTimer();
        };
    });
    var startCloseTimer = function () {
        closeTimer = setTimeout(function () {
            close();
        }, (duration !== null && duration !== void 0 ? duration : 4.5) * 1000);
    };
    var clearCloseTimer = function () {
        if (closeTimer) {
            clearTimeout(closeTimer);
            closeTimer = null;
        }
    };
    var close = function () {
        if (onClose) {
            onClose();
        }
    };
    var toggleExpandable = function () {
        setIsExpanded(!isExpanded);
    };
    return React.createElement(StyledNotification, { className: notificationClassname },
        React.createElement("div", { className: isExpandable
                ? 'notification-title notification-title-expandable'
                : 'notification-title' },
            thumbnail &&
                React.createElement("div", { className: "thumbnail" }, thumbnail),
            title && React.createElement("h3", { className: "title" }, title),
            React.createElement("div", { className: "message" }, message),
            isExpandable &&
                React.createElement("div", { className: "btn-close", onClick: toggleExpandable },
                    React.createElement(Icon, { name: "arrow-down" })),
            React.createElement("div", { className: "btn-close", onClick: close },
                React.createElement(Icon, { name: "close" }))),
        isExpandable && expandableContent && isExpandableVisible &&
            React.createElement("div", { className: isExpanded ? 'expandable-content open' : 'expandable-content' }, expandableContent));
};
export default Notification;
//# sourceMappingURL=notification.js.map